export const arraySortByUpdatedAt = (array) =>
  array.sort((a, b) => {
    const updatedAtA = new Date(a.attributes.updatedAt);
    const updatedAtB = new Date(b.attributes.updatedAt);

    return updatedAtB - updatedAtA;
  });
